import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsWrapperComponent } from './components/settings-wrapper/settings-wrapper.component';
import { SharedModule } from '../~shared/modules/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { SecurityFormComponent } from './components/security-form/security-form.component';
import { AdminCreationFormComponent } from './modals/admin-creation-form/admin-creation-form.component';
import { UserListComponent } from './components/user-list/user-list.component';

const DECLARATIONS = [
  SettingsWrapperComponent,
  SecurityFormComponent,
  AdminCreationFormComponent,
  UserListComponent
];

const MODULES = [CommonModule, MatTabsModule, SharedModule];

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...MODULES],
  exports: [...DECLARATIONS, ...MODULES]
})
export class SettingsModule {}
